// src/services/dashboardService.js
import api from './api';

/**
 * Get dashboard statistics and overview
 * @returns {Promise<Object>} Dashboard stats including overview, recent activity, etc.
 */
export const getDashboardStats = async () => {
  try {
    const response = await api.get('/api/admin/dashboard/stats');
    return response.data;
  } catch (error) {
    console.error('Dashboard stats error:', error);
    throw new Error(error.message || 'Failed to fetch dashboard statistics');
  }
};

/**
 * Get detailed analytics for dashboard
 * @returns {Promise<Object>} Analytics data including trends and charts
 */
export const getDashboardAnalytics = async () => {
  try {
    const response = await api.get('/api/admin/dashboard/analytics');
    return response.data;
  } catch (error) {
    console.error('Dashboard analytics error:', error);
    throw new Error(error.message || 'Failed to fetch dashboard analytics');
  }
};

/**
 * Get system health status
 * @returns {Promise<Object>} System health information
 */
export const getSystemHealth = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    console.error('System health error:', error);
    throw new Error(error.message || 'Failed to fetch system health');
  }
};
